import React from 'react'

const ClientLeadCard = () => {
  return (
    <div>
          <div className='row'>


<div className='col-xxl-3 col-md-6'>
    <div className='card info-card sales-card'>
        <div className='card-body'>
            <h5 className='card-title'>
                Total Clients <span></span>
            </h5>

            <div className='d-flex align-items-center'>
                <div className='card-icon rounded-circle d-flex align-items-center justify-content-center'>
                    <i className='bi bi-twitch'></i>
                </div>
                <div className='ps-3'>
                    <h6>145</h6>
                </div>
            </div>
        </div>
    </div>
</div>


</div>
    </div>
  )
}

export default ClientLeadCard
